import { ReportPage } from './ReportPage';

export function UtilisationForecast() {
  return <ReportPage reportName="Utilisation forecast" />;
}
